export function transformFromBackendLayout(backendType: any) { // eslint-disable-line
  return {
    id: backendType.id,
    name: backendType.name,
    layout: JSON.parse(backendType.layout),
    is_global: backendType.is_global,
    sygno_default: backendType.sygno_default,
    is_installation: backendType.is_installation,
    tenant_default: backendType.tenant_default,
  };
}
